export type { TextInputProps } from './TextInput'
export { TextInput } from './TextInput'
